/* unplugin-vue-components disabled */import { render } from "./DualChoiceToggle.vue?vue&type=template&id=639d6c5f&scoped=true&ts=true"
import script from "./DualChoiceToggle.vue?vue&type=script&lang=ts"
export * from "./DualChoiceToggle.vue?vue&type=script&lang=ts"

import "./DualChoiceToggle.vue?vue&type=style&index=0&id=639d6c5f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639d6c5f"]])

export default __exports__